import apiZelo from '../backAxiosVendaToken';
import { backAxiosImageZetec } from '../backAxiosImagenZtec';
import { retornoHashValor } from '../../modulos/cripotografia/hash';

const url = retornoHashValor(process.env.REACT_APP_1);
const token = localStorage.getItem('token');

let retorno;

export const insereAssinatura = async (inscricao, value) => {
    try {
        const response = await apiZelo.post(
            '/file-assinatura',
            value
        );

        return response.data;
    } catch (error) {
        return error.message;
    }
};

export const BuscaAssinat = async (inscricao, key ) => {
    const apiZetec = await backAxiosImageZetec(key);

    try {
        const response = await apiZetec.get(
            `contract/manager/v1/contracts/${inscricao}/signatures`
        );

        return response.data;
    } catch (error) {
        return error.message;
    }
};

export const BuscarImagem = async inscricao => {
    try {
        const response = await apiZelo.get(
            `/file-assinatura/${inscricao}`
        );

        return response.data;
    } catch (error) {
        return error.message;
    }
};

export const BuscarDadosTestemunha  = async inscricao => {
    try {
        const response = await apiZelo.get(
            `/file-assinatura/ass-testemunha/${inscricao}`
        );

        return response.data;
    } catch (error) {
        return error.message;
    }
};

export const insereAceite = async valor => {
    await fetch(`${url}/assinatura`, {
        headers: {
            'Content-Type': 'application/json',
            'x-auth-token': token
        },
        method: 'POST',
        body: JSON.stringify(valor)
    })
        .then(response => {
            retorno = response.json();
        })
        .catch(err => {
            retorno = err.message;
        });

    return retorno;
};

export const enviarLinkAlteracaoCartao = async valor => {
    try{
        const response = await apiZelo.post('/assinatura/enviar-link-cartao', valor);

        return response;
    }catch(err){
        return err;
    }
};

export const BuscaAceite = async codigo => {
    try {
        const response = await apiZelo.get(
            `assinatura/${codigo}`
        );

        //Retorna um array vazio caso não possua os dados
        if (response && response.data && !response.data.length) {return [];}

        return response.data;
    } catch (error) {
        return new Error(error);
    }
};

export const BuscaAceiteUnico = async inscricao => {
    try {
        const response = await apiZelo.get(`assinatura/unica/${inscricao}`);

        return response.data;
    } catch (error) {
        return error.message;
    }
};

export const ReenviaRemessa = async inscricao => {
    try {
        const response = await apiZelo.get(`assinatura/unica/${inscricao}`);

        return response.data;
    } catch (error) {
        return error.message;
    }
};